import type { MigrationTask } from '@schema';
import {
  type MappedProgressUpdate,
  formatTaskType,
  taskStatusIcon,
  mapProgressUpdates
} from '@/common/utils/taskMapper';

export type { MappedProgressUpdate };

export interface MappedMigrationTask {
  id: string;
  index: number;
  taskType: string;
  taskTypeText: string;
  status: string;
  statusText: string;
  statusIcon: string;
  instance: string;
  exceptionDetails: string | null;
  progressUpdates: MappedProgressUpdate[];
  /** Latest disk replication progress percent (>0) from progress_updates, if any. */
  currentProgress: number | null;
  createdAt: string;
  updatedAt: string;
}

const latestPositiveProgressPercent = (updates: MappedProgressUpdate[]): number | null => {
  const withProgress = updates.filter(
    update => update.progress != null && typeof update.progress === 'number' && update.progress > 0
  );
  if (!withProgress.length) {
    return null;
  }
  withProgress.sort((firstUpdate, secondUpdate) => firstUpdate.index - secondUpdate.index);
  return withProgress[withProgress.length - 1].progress ?? null;
};

export const mapMigrationTask = (task: MigrationTask): MappedMigrationTask => {
  const progressUpdates = mapProgressUpdates(task.progress_updates);
  return {
    id: task.id ?? '',
    index: task.index ?? 0,
    taskType: task.task_type ?? '',
    taskTypeText: formatTaskType(task.task_type ?? ''),
    status: task.status ?? '',
    statusText: formatTaskType(task.status ?? ''),
    statusIcon: taskStatusIcon(task.status ?? ''),
    instance: task.instance ?? '',
    exceptionDetails: task.exception_details ?? null,
    progressUpdates,
    currentProgress: latestPositiveProgressPercent(progressUpdates),
    createdAt: task.created_at ?? '',
    updatedAt: task.updated_at ?? ''
  };
};
